interface Props {
  status: string
}

const map: Record<string, { label: string; cls: string }> = {
  ready: {
    label: 'Готово',
    cls: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950/30 dark:text-emerald-400',
  },
  // Naming invariant: partial_sim = sim track survived (operator silent);
  // partial_op = operator survived (callee silent). Label describes the
  // MISSING side so the operator immediately sees what's degraded.
  partial_sim: {
    label: 'Без голоса оператора',
    cls: 'bg-amber-50 text-amber-800 dark:bg-amber-950/30 dark:text-amber-300',
  },
  partial_op: {
    label: 'Без голоса callee',
    cls: 'bg-amber-50 text-amber-800 dark:bg-amber-950/30 dark:text-amber-300',
  },
  merge_failed: {
    label: 'Ошибка merge',
    cls: 'bg-red-50 text-red-700 dark:bg-red-950/30 dark:text-red-400',
  },
  // incomplete = canonical playable, late fragment lost on concat eviction.
  // Distinct color (orange) so admin doesn't confuse it with partial_*
  // (amber, one side silent ALL call) or merge_failed (red, no file).
  incomplete: {
    label: 'Фрагмент потерян',
    cls: 'bg-orange-100 text-orange-800 dark:bg-orange-950/30 dark:text-orange-300',
  },
  deleted: {
    label: 'Удалено',
    cls: 'bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400',
  },
}

export function RecordingStatusBadge({ status }: Props) {
  const entry = map[status] ?? { label: status, cls: 'bg-gray-100 text-gray-600' }
  return (
    <span
      data-testid="rec-status-badge"
      className={`inline-block text-xs font-medium px-2 py-0.5 rounded ${entry.cls}`}
    >
      {entry.label}
    </span>
  )
}
